import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/post_registration/$')({
  component: JourneysLegacyAuthRefreshRoute,
});
